import type { IDropdownItemsGroupProps } from './DropdownItemsGroup'

import { styled } from '@linaria/react'
import { COLOR, CORNERS } from 'vars/index'
import {
  DropdownItemsGroupAlignItems,
  DropdownItemsGroupDirection,
  DropdownItemsGroupJustifyContent,
} from './DropdownItemsGroup.h'

export const DropdownItemsGroupStyled = styled.div<
  IDropdownItemsGroupProps & {
    dropdownItemsGroupWidth?: number
    dropdownItemsGroupHeight?: number
  }
>`
  width: ${({ dropdownItemsGroupWidth }) =>
    dropdownItemsGroupWidth ? `${dropdownItemsGroupWidth}px` : 'auto'};
  max-height: ${({ dropdownItemsGroupHeight }) =>
    dropdownItemsGroupHeight ? `${dropdownItemsGroupHeight}px` : 'auto'};
  max-width: 100%;
  overflow: auto;
  display: flex;
  flex-direction: ${({ direction }) =>
    direction || DropdownItemsGroupDirection.Row};
  justify-content: ${({ justifyContent }) =>
    justifyContent || DropdownItemsGroupJustifyContent.FlexStart};
  align-items: ${({ alignItems }) =>
    alignItems || DropdownItemsGroupAlignItems.FlexStart};
  padding: ${({ paddings }) =>
    paddings && paddings.length > 0
      ? paddings.map((item) => `var(${item})`)?.join(' ')
      : 0};
  background-color: var(${COLOR.BACKGROUND_DARK});
  border-radius: var(${CORNERS.CORNERS_BOTTOM_10});
  gap: ${({ gap }) => (gap ? `var(${gap})` : 'initial')};

  &:not(:last-child) {
    border-right: ${({ withDivider }) =>
      withDivider
        ? `1px solid var(${COLOR.SURFACE_OPACITY_LIGHT_10})`
        : 'initial'};
  }

  &[data-multiColumns='true'] {
    display: grid;
    grid-template-areas: 'a a';
    grid-auto-rows: min-content;
  }

  & > a,
  form {
    width: 100%;
  }

  &::-webkit-scrollbar {
    width: 4px;
    height: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: var(${COLOR.SURFACE_OPACITY_LIGHT_10});
    border-radius: 2px;
    cursor: pointer;
  }
`
